import {
  PudoOption,
  PudoOptionInput,
  SelectedPudoOption,
} from "@narvar/nth-kit-returns-headless";

export const getPudoMethodName = (
  pudoOption?: PudoOption | SelectedPudoOption | PudoOptionInput | null,
) => {
  if (!pudoOption) return "";

  const { pudoActionType, pudoActionTypeDetails, pudoProvider } = pudoOption;
  if (pudoActionType === "DROP_OFF") {
    if (pudoActionTypeDetails === "LABEL") {
      if (pudoProvider?.type === "CARRIER") return "mail";
      if (pudoProvider?.type === "CONCIERGE") return "concierge";
      if (pudoProvider?.type === "STORE") return "store";
      return "self";
    }
    if (pudoActionTypeDetails === "PRINTERLESS") return "printerless_mail";
    if (pudoActionTypeDetails === "BOXLESS") return "boxless";
  } else if (pudoActionType === "PICK_UP") {
    if (pudoProvider?.type === "COURIER") return "pickup";
  }
  return "";
};

export const generatePudoId = (
  pudoOption?: PudoOption | SelectedPudoOption | PudoOptionInput | null,
) => {
  if (!pudoOption) return "";
  const { pudoActionType, pudoActionTypeDetails, pudoProvider, serviceType } =
    pudoOption;
  return [
    pudoActionType,
    pudoActionTypeDetails,
    pudoProvider?.type,
    pudoProvider?.moniker,
    serviceType,
    pudoProvider?.carrierId,
  ].join("-");
};
